import React from 'react';
import Portal from 'new/elements/Portal';
import GenAiChatNode from './GenAiChatNode';

interface DraggableGenAiChatNodeProps {
  id: string;
  data: {
    onClose: () => void;
    onStreamComplete: () => void;
  };
  nexsetId: string;
  isFlowExpanded: boolean;
}

export const DraggableGenAiChatNode: React.FC<DraggableGenAiChatNodeProps> = ({
  id,
  data,
  nexsetId,
  isFlowExpanded,
}) => {
  return (
    <Portal>
      <GenAiChatNode
        id={id}
        data={data}
        nexsetId={nexsetId}
        position={{
          x: window.innerWidth - 470,
          y: window.innerHeight - 410,
        }}
        isFlowExpanded={isFlowExpanded}
      />
    </Portal>
  );
};

export default DraggableGenAiChatNode;
